<template>
    <div>
        <v-card class="news-card" @click="showArticleDialog=true">
            <div v-if="article.video_url" @click.stop v-html="embedVideo"/>
            <div
                v-if="hasCoverImage(article.files)"
            >
                <img 
                    :src="coverImage(article.files)"
                    style="width: 100%;max-height: 200px;object-fit: cover;"
                />
            </div>
            <v-card-text style="padding: 10px;padding-top: 5px;">
                <h2>
                    {{ article.title }}
                </h2>
                <div>
                    <p
                        class="news-card-text"
                        v-html="article.body"
                    />
                </div>
            </v-card-text>
            <v-card-actions>
                <span>{{ convertToLocalWithoutTime(article.published)}}</span>
                <v-spacer/>
                <span v-if="numberOfFiles > 0">{{ numberOfFiles }}<v-icon style="margin-right: 10px;">mdi-file</v-icon></span>
                <v-btn @click="showArticleDialog = true">
                    Read More
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog
            v-model="showArticleDialog"
            scrollable
            width="900px"
        >
            <v-card
                class="news-dialog"
            >
                <v-toolbar
                    style="height: auto !important;max-height: unset;"
                >
                    <div
                        style="font-size: 18px;"
                        v-if="article.video_url"
                    >
                        {{ article.title }}
                    </div>
                    <v-spacer />
                    <v-btn
                        color="red"
                        dark
                        icon
                        @click="showArticleDialog = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-toolbar>
                <div
                    style="overflow-y:scroll;"
                >
                    <div v-if="article.video_url" style="text-align: center;" @click.stop v-html="embedArticleVideo"/>
                    <div
                        v-if="hasCoverImage(article.files)"
                        style="text-align: center;"
                    >
                        <img 
                            :src="coverImage(article.files)"
                            style="max-width: 100%;max-height: 300px;"
                        />
                    </div>
                    <v-card-text>
                        <div>
                            <div
                                style="font-size: 24px;font-weight: bold;"
                                v-if="!article.video_url"
                            >
                                {{ article.title }}
                            </div>
                            <p
                                v-html="article.body"
                            />
                        </div>
                        <div
                            v-if="numberOfFiles > 0"
                        >
                            <div 
                                v-for="file in article.files"
                                :key="file.id"
                                style="color:#1565C0;display: flex;cursor:pointer;padding: 10px;"
                                @click="downloadFile(file.id, file.file)"
                                v-if="!file.cover_image"
                            >
                                <b style="padding-right: 10px;">{{ file.file }}</b>
                                <v-icon
                                    color="#1565C0"
                                >
                                    mdi-cloud-download
                                </v-icon>
                            </div>
                        </div>
                    </v-card-text>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import api from '@/api'
import embed from 'embed-video'

export default {
    name:'NewsCard',
    props: ['article'],
    data(){
        return {
            showArticleDialog: false
        }
    },
    computed: {
        numberOfFiles() {
            return this.article.files.filter(file => !file.cover_image).length
        },
        embedVideo () {
            return embed(this.article.video_url, {attr: {height: 300, class: 'embed', frameborder: "0"}})
        },
        embedArticleVideo () {
            return embed(this.article.video_url, {attr: {height: 453, class: 'embed', frameborder: "0"}})
        }
    },
    methods: {
        downloadFile (fileId, file_name) {
            let fileDl = (this.article.casetype)
                ? api.news.casenews.downloadFileUrl(this.article.casetype.id, this.article.id, fileId)
                : api.news.news.downloadFileUrl(this.article.id, fileId)
            fileDl.then((response) => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = file_name.replace(/['"]/g, '')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
        },
        coverImage (files) {
            var tmp = null
            files.forEach((f) => {
                if (f.cover_image) {
                    tmp = f.id
                }
            })
            if (tmp) {
                tmp = api.news.cover_image.filePath(tmp)
            }
            return tmp
        },
        hasCoverImage (files) {
            var tmp = false
            files.forEach((f) => {
                if (f.cover_image) {
                    tmp = true
                }
            })
            return tmp
        }
    }
}
</script>

<style scoped>

.news-card-text {
    overflow: hidden;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 6; /* number of lines to show */
            line-clamp: 6; 
    -webkit-box-orient: vertical;
}

.news-card-files {
    padding: 10px;
}

</style>

<style>

.news-dialog .v-toolbar__content {
    height: auto !important;
    padding-top: 5px;
    padding-bottom: 5px;
}

.embed {
    width: 100%;
    border: none;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}
</style>